import { AfterContentInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToothStatus } from '@features/client/order-workflow/enums/tooth-status.enum';
import { ToothPart } from '@features/client/order-workflow/enums/tooth-part.enum';
import { SelectedTooth, Tooth } from '@features/client/order-workflow/models/tooth.model';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { AssetExistsPipe } from '@shared/pipes/asset-exists.pipe';
import { ToothIconComponent } from '@features/client/order-workflow/components/tooth-icon/tooth-icon.component';

@Component({
  selector: 'app-tooth',
  templateUrl: './tooth.component.html',
  styleUrls: ['./tooth.component.scss'],
  imports: [NgStyle, NgClass, AssetExistsPipe, AsyncPipe, ToothIconComponent],
})
export class ToothComponent implements AfterContentInit {
  @Input() public active: boolean;
  @Input() public showRoot: boolean;
  @Input() public tooth: Tooth;
  @Input() public selectedTooth: SelectedTooth;
  @Input() public readonly: boolean;
  @Input() public showHoverEffect: boolean;
  @Input() public isPartOfZone: boolean;
  @Output() public toothPartClick: EventEmitter<ToothPart> = new EventEmitter<ToothPart>();
  @ViewChild('toothElement', { static: true }) public toothElement: ElementRef;

  public toothHeight: number;
  public toothStatus: typeof ToothStatus = ToothStatus;
  public toothPart: typeof ToothPart = ToothPart;
  public iconPath: { root: string; crown: string } = {
    root: null,
    crown: null,
  };

  public ngAfterContentInit(): void {
    this.toothHeight =
      this.toothElement.nativeElement.offsetWidth < 25 ? 25 : this.toothElement.nativeElement.offsetWidth;
  }

  public handleToothPartClick(toothPart: ToothPart): void {
    const isRotaryDialOpen = document.getElementsByTagName('app-rotary-dial').length;
    const isCrownActionsOpen = document.getElementsByTagName('app-crown-actions').length;

    if (!isRotaryDialOpen && !isCrownActionsOpen && !this.readonly) {
      this.toothPartClick.emit(toothPart);
    }
  }
}
